import get from "lodash/get";
import { SIM_TYPES, NUMBER_TYPES } from "utils/constants";
import { BRANCH_STANDARD_EVENT } from "constants/AnalyticsTypeConstants";

export const constructBranchIOPurchaseEventData = (
  data,
  reduxStore,
  userSelectedPlan = {}
) => {
  return {
    branch_standard_event: get(BRANCH_STANDARD_EVENT, "PURCHASE", ""),
    data: {
      transaction_id: get(data, "order.orderReference", null),
      value: get(data, "charge_amount", null),
      sim_type: get(SIM_TYPES, `${get(data, "order.simType")}`, null),
      number_type: get(NUMBER_TYPES, `${get(data, "order.numberType")}`, null),
      plan_type: get(userSelectedPlan, "productCategory", null),
      plan_id: get(userSelectedPlan, "sku", null),
      customer_id: get(data, "user_id", null)
    }
  };
};
